import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/useAuth";
import "./Setup.css";

import setupImage from "../../Assets/setup.png";


interface Props {}

const SetupSection = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();
  return (
    <div className="container mt-5">
        <div className="card shadow-sm p-4">
            <div className="row align-items-center">
            <div className="col-md-6">
                <img
                src={setupImage} className="hero-image p-0 img-fluid rounded"
                alt="Part"
                />
            </div>
            <div className="col-md-4">
                <h3>Trek Fuel EX</h3>
                <p className="text-muted">2023 Trail Bike</p>
            </div>
            <div className="col-md-2">
                <button 
                className="btn btn-primary mt-3">Buy now
                </button>
            </div>
            </div>
        </div>
    </div>
  );
}

export default SetupSection;
